export function SuccessIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <title>Success</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.33C14.6 18.33 18.33 14.6 18.33 10C18.33 5.4 14.6 1.67 10 1.67C5.4 1.67 1.67 5.4 1.67 10C1.67 14.6 5.4 18.33 10 18.33Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.79 7.21C15.07 7.49 15.07 7.94 14.79 8.22L9.33 13.686C8.91 14.1 8.23 14.1 7.81 13.686L5.21 11.08C4.93 10.8 4.93 10.35 5.21 10.07C5.49 9.79 5.94 9.79 6.22 10.07L8.57 12.42L13.78 7.21C14.06 6.93 14.51 6.93 14.79 7.21Z"
        fill="white"
      />
    </svg>
  );
}
